export const constant = ['tmrAppName', 'Benetton TMR - Frontend']
